import React from "react";
import CommonDialog from "../../../CommonDialog";
import { useFormik } from "formik";
import * as yup from "yup";
import { DialogActions, DialogContent, Grid, Stack } from "@mui/material";
import TextFieldLabel from "app/components/common/TextFieldLabel";
import { CustomTextField } from "assets/styles/globalStyledComponent";
import { LoadingButton } from "@mui/lab";
import { useMutation } from "react-query";
import { updateBookRate } from "app/services/ledgerAccount";
import { toast } from "react-toastify";

const UpdateBookSale = ({
  open = false,
  onClose = () => {},
  refetch = () => {},
  selectedBook = {},
}) => {
  const editFormik = useFormik({
    initialValues: {
      buyingRate: "",
      sellingRate: "",
    },
    validationSchema: yup.object({
      buyingRate: yup.number().required("buyingRate is required"),
      sellingRate: yup.number().required("sellingRate is required"),
    }),
    onSubmit: (values) => {
      updateBookRateMutate({
        bookDocId: selectedBook?._id,
        buyingRate: values.buyingRate,
        sellingRate: values.sellingRate,
      });
    },
  });

  const {
    mutate: updateBookRateMutate,
    isLoading: updateBookRateMutateLoading,
  } = useMutation(updateBookRate, {
    onSuccess: (success) => {
      refetch();
      handleClose();
      toast.success(success?.data?.message);
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
    onSettled: () => {
      editFormik.resetForm();
    },
  });
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <CommonDialog
        open={open}
        onClose={handleClose}
        minWidth="400px"
        title="Update Book Rate"
      >
        <form onSubmit={editFormik.handleSubmit}>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                {/* exsting buying */}
                <Stack>
                  <TextFieldLabel title="Existing Buying Rate" />
                  <CustomTextField
                    size="small"
                    fullWidth
                    name="exisitingBuyingRate"
                    value={selectedBook?.buyingRate ?? ""}
                    disabled
                  />
                </Stack>
                {/* current buying */}
                <Stack>
                  <TextFieldLabel title="New Buying Rate" />
                  <CustomTextField
                    size="small"
                    fullWidth
                    name="buyingRate"
                    value={editFormik?.values.buyingRate}
                    onChange={editFormik?.handleChange}
                    placeholder="type buying Rate"
                    type="number"
                    error={
                      Boolean(editFormik?.errors.buyingRate) &&
                      editFormik?.touched.buyingRate
                    }
                    helperText={
                      editFormik?.touched.buyingRate &&
                      editFormik?.errors.buyingRate
                    }
                  />
                </Stack>
              </Grid>
              <Grid item xs={6}>
                {/* exsting buying */}
                <Stack>
                  <TextFieldLabel title="Existing Selling Rate" />
                  <CustomTextField
                    size="small"
                    fullWidth
                    name="exisitingBuyingRate"
                    value={selectedBook?.sellingRate ?? ""}
                    disabled
                  />
                </Stack>
                <Stack>
                  <TextFieldLabel title="New Selling Rate" />
                  <CustomTextField
                    size="small"
                    fullWidth
                    name="sellingRate"
                    value={editFormik?.values.sellingRate}
                    onChange={editFormik?.handleChange}
                    placeholder="type Selling rate"
                    type="number"
                    error={
                      Boolean(editFormik?.errors.sellingRate) &&
                      editFormik?.touched.sellingRate
                    }
                    helperText={
                      editFormik?.touched.sellingRate &&
                      editFormik?.errors.sellingRate
                    }
                  />
                </Stack>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <LoadingButton
              type="submit"
              variant="contained"
              color="secondary"
              loading={updateBookRateMutateLoading}
            >
              Update
            </LoadingButton>
          </DialogActions>
        </form>
      </CommonDialog>
    </>
  );
};

export default UpdateBookSale;
